import React from 'react';
import LaneContainer from '../UI/LaneContainer';
import LoadingSpinner from '../UI/LoadingSpinner';
import YourBooksSectionHeader from '../YourBooks/YourBooksSectionHeader';
import { connectToDownloads } from './containers/DownloadsDataStore';
import DownloadsCollapse from './DownloadsCollapse';
import DownloadsMenu from './DownloadsMenu';

export class Downloads extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showInGrid: false,
		};
	}

	componentDidMount() {
		this.initializeSource();
	}

	initializeSource = () => {
		if (this.props.match) {
			this.setState({ showInGrid: true });
		}
	};

	render() {
		const { showInGrid } = this.state;
		const { isLoading } = this.props.downloadsDataStore.state;
		return (
			<div
				style={{
					marginTop: showInGrid ? 64 : 0,
				}}>
				<LaneContainer
					majorHeader={
						<YourBooksSectionHeader
							headerText="Your Downloads"
							showInGrid={showInGrid}
						/>
					}>
					<React.Fragment>
						{!isLoading ? (
							<div>
								{showInGrid ? (
									<DownloadsMenu />
								) : (
									<DownloadsCollapse />
								)}
							</div>
						) : (
							<LoadingSpinner />
						)}
					</React.Fragment>
				</LaneContainer>
			</div>
		);
	}
}
export default connectToDownloads(Downloads);
